const regExp = /^(-?\d+)(\d{3})/

export default function filterIntcomma(number: any) {
  let prevStr = ''
  let currentStr = String(number)

  while (prevStr !== currentStr) {
    prevStr = currentStr
    currentStr = currentStr.replace(regExp, '$1\xa0$2')
  }

  return currentStr
}
